import { keycloakConfig } from './config';

// Pure — reads only static config, no window/document access at module scope.
// Safe to deep-import (`@coverright/shared/keycloak/create-login-url`) from
// Next.js SSR contexts, unlike the barrel (`keycloak.tsx` instantiates a
// Keycloak client at module scope).
export const createLoginUrl = (redirectUri = document.location.href) => {
  return `${keycloakConfig.url}realms/${keycloakConfig.realm}/protocol/openid-connect/auth?client_id=${keycloakConfig.clientId}&redirect_uri=${encodeURI(redirectUri)}&response_mode=fragment&response_type=code&scope=openid`;
};
